import InnoIcons from "@InnoIcons/";
import { Tooltip } from "antd";
import Ingested from "@assets/images/Ingested.png";
import Summarized from "@assets/images/Summarized.png";

const PointIdIndicator = (props) => {
  const { knowledgeStatus } = props;

  if (knowledgeStatus === 1) {
    return (
      <Tooltip
        title="Knowledge ingested but summary not generated by AI"
        placement="right"
      >
        <img src={Ingested} alt="Ingested" style={{ width: 22, height: 22 }} />
      </Tooltip>
    );
  }

  if (knowledgeStatus === 2) {
    return (
      <Tooltip title="Knowledge Summarized" placement="right">
        <img
          src={Summarized}
          alt="Summarized"
          style={{ width: 22, height: 22 }}
        />
      </Tooltip>
    );
  }

  if (knowledgeStatus === 3) {
    return (
      <Tooltip title="Knowledge Completed" placement="right">
        <InnoIcons.CheckCircleIcon
          sx={{ color: "#52c41a", fontSize: "20px" }}
        />
      </Tooltip>
    );
  }

  return <span>--</span>;
};

export default PointIdIndicator;
